/**
 * We have now multiple places where manually put tags to invalidate.
 * It can be challenging to remember all of them so this places tries
 * to centralize and normalize via factories the generation of IDs.
 */
import { tagTypes } from '../constants';

const tagFactory = {
  [tagTypes.UnitRenewalOrders]: {
    orgOrders: (organizationGuid: string) => ({
      type: tagTypes.UnitRenewalOrders,
      id: organizationGuid,
    }),
  },
  [tagTypes.UserActivitySummary]: {
    /** Tags the activities summary for a youth */
    userSummary: (userId: number) => ({
      type: tagTypes.UserActivitySummary,
      id: `${userId}`,
    }),
  },
  [tagTypes.Activities]: {
    /** Tag a list of activites for a whole unit. */
    orgActivities: (organizationGuid: string) => ({
      type: tagTypes.Activities,
      id: `Org-${organizationGuid}`,
    }),
    /** For an activity returned inside the list. Useful if you want to invalidate but you don't know the personGuid or orgGuid */
    activityItem: (activityId: number) => ({
      type: tagTypes.Activities,
      id: `Activity-${activityId}`,
    }),
    /** Tag a list of activities associated to a single scout */
    youthActivities: (userId: string) => ({
      type: tagTypes.Activities,
      id: `Youth-${userId}`,
    }),
  },
};

export default tagFactory;
